import { useQuery } from 'react-query';
import { PerkId } from '../../../../types/TymbeApi';
import feathersClient from '../../../../apiClient';
import { getPaginatedResponse } from '../../../../apiClient/utils';
import Spinner from '../../../../components/Spinner';

interface TymberNoProps {
  perks: PerkId[];
  companyId?: number | string;
  departmentId?: number | string;
  templateId?: number | string;
}

const TymberNo = ({ perks, companyId, departmentId, templateId }: TymberNoProps) => {
  const { data: tymberCount, isLoading } = useQuery({
    queryKey: ['tymberCount', perks],
    queryFn: async () => {
      const modify = {
        ...(perks.includes(PerkId.COMPANY_SENIOR) && { workedForCompany: [companyId] }),
        ...(perks.includes(PerkId.BRANCHOFFICE_SENIOR) && { workedForBranch: [departmentId] }),
        ...(perks.includes(PerkId.POSITION_SENIOR) && { workedAtPosition: [templateId] }),
        ...(perks.includes(PerkId.ADULT) && { adult: true }),
        ...(perks.includes(PerkId.WOMAN_ONLY) && { womanOnly: true }),
        ...(perks.includes(PerkId.MAN_ONLY) && { manOnly: true }),
      };

      const res = await feathersClient.service('person-perks').find(
        {
          query: {
            $modify: { ...modify },
            $limit: 0,
          },
        },
      );
      return getPaginatedResponse(res).total;
    },
    cacheTime: 1000 * 60 * 60, // 1 hour
  });

  if (isLoading) return <Spinner show={isLoading} className="w-8 p-1 m-auto" />;

  return (
    <div className="text-xs text-danger p-1">
      Vaši objednávku vidí přesně {tymberCount} Tymberů.
      Chcete více kandidátů? Zkuste odebrat některé filtry a oslovit tak více brigádníků!
    </div>
  );
}

export default TymberNo;
